import { render, staticRenderFns } from "./VDataTableUsers.vue?vue&type=template&id=2a24d41c&scoped=true"
import script from "./VDataTableUsers.vue?vue&type=script&lang=js"
export * from "./VDataTableUsers.vue?vue&type=script&lang=js"
import style0 from "./VDataTableUsers.vue?vue&type=style&index=0&id=2a24d41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a24d41c",
  null
  
)

export default component.exports